import React from 'react';
import Todo from './pages/todo';
import  './pages/todo.css';
function App() {
  return (
    <div className="App">
     <Todo/>
    </div>
  );
}

export default App;
